// extracted by mini-css-extract-plugin
module.exports = {"container":"_6bf55ce5dc--container--ktXmQ","link":"_6bf55ce5dc--link--acwir","link-area":"_6bf55ce5dc--link-area--bIF7s"};